import React from "react";
import TimePicker, { TimePickerProps } from "react-time-picker";

import "./index.scss";

interface IProps extends TimePickerProps {
  label: string
}

const TimeInput = ({ value, label, onChange }: IProps) => {

  return (
    <div className="TimeInput">
      <label><span>{label}</span></label>
      <TimePicker
        disableClock
        value={value}
        maxDetail="second"
        clockIcon={null}
        onChange={onChange}
      />
    </div>
  )
}

export { TimeInput }
